import React from 'react';

export default React.createContext({
  urlLang: "",
  connected: false,
  hasMdp: false,
  authenticationStatus: 2,
  establishment: {},
  languages: [],
  countries: [],
  identityDocuments: [],
  translations: {},
  user: {},
  listDossier: [],
  listResa: [],
  listParametres: [],
  headerPage: {},
  userActionTypes: [],
  userActions: [],
  salesTermsAndConditions: "",
  modalIsOpen: false,
  messages: [],
  displayControl: {},
  establishmentCollection: {}
});